var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProhibitionColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_prohibition_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres",
    transform: "translate(-815.500000, -552.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(776.000000, 521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_prohibition_color",
    transform: "translate(36.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 20,
    cy: 20,
    r: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 9.5,
    x2: 30.5,
    y2: 30.5,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProhibitionColor);
export default __webpack_public_path__ + "static/media/icon_prohibition_color.ce457999786126f298f5254810d4e34f.svg";
export { ForwardRef as ReactComponent };